import { createContext } from 'react';

/** True inside a <Layout> drawn with the new navigation on: an inner <Layout> then returns just its children. */
export const ShellContext = createContext(false);
